<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Υπεργολάβοι</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createSubcontractor()">Προσθήκη υπεργολάβου</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            sorter
            @row-clicked="(item) => showSubcontractor(item.id)"
            clickable-rows
          >
          <template #afm="{item}">
            <td>
              {{ getAfmText(item.afm) }}
            </td>
          </template>
          <template #profession="{item}">
            <td>
              {{ getProfessionText(item.profession) }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editSubcontractor( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  { 
    key: 'name', 
    label: 'Ονοματεπώνυμο'
  },
  {
    key: 'afm', 
    label: 'ΑΦΜ', 
    sorter: true, 
    filter: true
  },
  { 
    key: 'profession', 
    label: 'Επάγγελμα'
  },
  {
    key: 'activity',
    label: 'Δραστηριότητα'
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Subcontractors',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      alertIsShown: false,
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getAfmText (afm) {
      if (!afm) {
        return '-';
      } else {
        return afm;
      }
    },
    getProfessionText (profession) {
      if (!profession) {
        return '-';
      } else {
        return profession;
      }
    },
    subcontractorsLink (id) {
      return `subcontractors/${id.toString()}`
    },
    editLink (id) {
      return `subcontractors/${id.toString()}/edit`
    },
    showSubcontractor ( id ) {
      const subcontractorsLink = this.subcontractorsLink( id );
      this.$router.push({path: subcontractorsLink});
    },
    editSubcontractor ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    // deleteSubcontractor ( id ) {
    //   let self = this;
    //   let subcontractorsId = id;
    //   axios.post('/api/subcontractors/' + id + '?token=' + localStorage.getItem("api_token"), {
    //     _method: 'DELETE'
    //   })
    //   .then(function (response) {
    //       self.message = 'Επιτυχής διαγραφή υπεργολάβου.';
    //       self.showAlert();
    //       self.getSubcontractors();
    //   }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: '/login' });
    //   });
    // },
    createSubcontractor () {
      this.$router.push({path: 'subcontractors/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getSubcontractors (){
      let self = this;
      axios.get('/api/subcontractors?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.subcontractors;
        self.you = response.data.you;
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getSubcontractors();
  }
}
</script>
